import React, { useEffect, useState } from 'react';
import UpcomingEventsList from '../upcoming-events/UpcomingEventsList';
import '../upcoming-events/UpcomingEventsList.css';
import './UpcomingEvents.css';
import api from '../wrapper/API';
import useLocations from '../../hooks/useLocations';
import { useTour } from '../context/TourContext';
import { UPCOMING_EVENTS_TOUR_KEY, upcomingEventsTourSteps } from '../tour/tours/upcomingEventsTour';

// Events entstehen ausschließlich unter „Event Prozesse" (/eventannouncement) — auch Feldmieten. Diese Seite
// listet sie nur (Bearbeiten/Absagen/Info über das Kontextmenü).
function UpcomingEvents() {
  const [posts, setPosts] = useState([]);
  const { isTourCompleted, startTour, tourReady } = useTour();

  useEffect(() => {
    if (!tourReady || posts.length === 0) return;
    if (!isTourCompleted(UPCOMING_EVENTS_TOUR_KEY)) {
      startTour(UPCOMING_EVENTS_TOUR_KEY, upcomingEventsTourSteps);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourReady, posts.length]);

  // One location list per page, handed to the edit popup (EventContextMenu loads it on demand).
  const locationsApi = useLocations();

  useEffect(() => {
    api.get('/Event/GetAllCombined')
      .then(response => {
        setPosts(response.data);
      })
      .catch(() => {});
  }, []);

  return (
    <React.Fragment>
      <div className={"generalContainer upcomingEventsPage"}>
        <div data-tour="upcoming-events-list">
          <UpcomingEventsList posts={posts} setPosts={setPosts} locationsApi={locationsApi} />
        </div>
      </div>
    </React.Fragment>
  );
}

export default UpcomingEvents;
